<template>
  <div class="container">
    <modal-container />
    <drawer />

    <div class="container__wrapper container__wrapper--topbar-adjust">
      <topbar>
        <div class="topbar__panel">
          <div class="topbar__heading">
            <h1>{{ counter.data.name }} ({{ counter.data.short_name }}) - {{ counter.data.group.name }}</h1>
          </div>
        </div>
      </topbar>

      <sidebar />

      <div class="content">
        <div class="content__wrapper">
          <page-loader v-if="false" />

          <div class="admin-pis">
            <div class="admin-pis__wrapper">
              <QueueToolbar
                :counter="counter.data"
                :counters="counters.data"
              />
              <div class="admin-pis__summary">
                <SummaryList />
                <SummaryList
                  type="priority"
                  class=" admin-pis__summary__list--priority"
                />
              </div>
              <CounterList
                :counters="counters.data"
                :current-counter="counter.data"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Topbar from '@components/Topbar'
import Sidebar from '@components/Sidebar'
import ModalContainer from '@components/modals/ModalContainer'
import Drawer from '@components/drawers/Drawer'
import PageLoader from '@components/shared/PageLoader'
import CounterList from '@components/CounterList'
import QueueToolbar from '@components/QueueToolbar'
import SummaryList from '@components/SummaryList'

export default {
  metaInfo () {
    return {
      title: `Counters (${this.counter.data.short_name})`,
    }
  },
  components: {
    SummaryList,
    QueueToolbar,
    CounterList,
    ModalContainer,
    Drawer,
    Topbar,
    Sidebar,
    PageLoader,
  },
  props: {
    counters: {
      type: Object,
      required: true,
    },
    counter: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$echo
      .channel('counter-called')
      .listen('CounterCalled', () => {
        this.$store.dispatch('queueing/getList', 'normal')
        this.$store.dispatch('queueing/getList', 'priority')
        this.$store.dispatch('queueing/getStatus')
      })
  },
}
</script>
